import React from 'react';

const ImageBackground = ({ imageUrl, cssClass }) => {
    return (
        <img src={imageUrl} className={cssClass} alt='' />
    )
}

export default ImageBackground;